import {Injectable, inject, signal, WritableSignal, computed, effect, untracked, OnDestroy} from '@angular/core';
import {BrowserMediaDevicesService} from './browser-media-devices.service';
import {AppVisibilityService} from '@serv/media_access/app_visibility.service';
import * as UtilityMediaAccess from '@serv/media_access/utility';
import {SpeechRecognitionService} from '@serv/media_access/speech-recognition.service';
import {DevicePermissionsService} from "@serv/media_access/devices_permissions.service";
import {SnackbarService} from "@serv/snackbar.service";
//import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({
  providedIn: 'root'
})
export class MicrophoneService implements OnDestroy {
  private _speechRecognitionService = inject(SpeechRecognitionService);
  private _devicesPermissionService = inject(DevicePermissionsService);
  private mediaDevices = inject(BrowserMediaDevicesService);
  private _appVisibilityService = inject(AppVisibilityService);
  private _snackbarService = inject(SnackbarService);
  //private _console = inject(Tools_aiConsoleService);

  private initialPrefix = signal<string>('')


  public permissionState: WritableSignal<UtilityMediaAccess.PermissionState> = signal('prompt');
  public readonly isAccessMicrophone = computed((): boolean => this._devicesPermissionService.permissionState() === 'granted');
  public error: WritableSignal<UtilityMediaAccess.MicrophoneError | null> = signal(null);
  public readonly transcriptionSession = computed(() => this.initialPrefix() + this._speechRecognitionService.transcriptionSession$())
  public isRecognizing = computed((): boolean => this._speechRecognitionService.isRecognizing$());
  private activeConsumer: WritableSignal<UtilityMediaAccess.MicrophoneConsumer> = signal(null);
  public readonly isLocked = computed(() => this.activeConsumer() !== null);
  private mediaStream: MediaStream | null = null;
  private permissionStatus: PermissionStatus | null = null;

  // VARIABLES PARA CONTROL
  private restartTimer: ReturnType<typeof setTimeout> | null = null;

  constructor() {

    // Effect para controlar el reinicio
    // effect(() => {
    //   const isRecognizing =this._speechRecognitionService.isRecognizing$()
    //   if (this.activeConsumer() && isRecognizing==false) {
    //     console.log('📱 Página visible - Reanudando escucha continua');
    //     this._speechRecognitionService.start();
    //   }
    // }, {'allowSignalWrites': true});


    // // Effect para gestionar consumidores - INICIAR/DETENER SOLO POR LOCKS
    // effect(() => {
    //   const needRecognizing = this.activeConsumer() && this.pageVisibility() && this.recognitionState() === UtilityMediaAccess.RecognitionState.IDLE;
    //   console.log(`🎯 Consumer: ${this.activeConsumer()}, Idle: ${this.recognitionState() === UtilityMediaAccess.RecognitionState.IDLE}, Visible: ${this.pageVisibility()}`);
    //
    //   untracked(() => {
    //     if (needRecognizing) {
    //       // HAY CONSUMIDOR -> INICIAR ESCUCHA CONTINUA
    //       //this._speechRecognitionService.start();
    //     }
    //   });
    // });

    //Effecto para controlar los cambios en los status de los permisos de acceso
    effect(()=>{
      if(this._devicesPermissionService.onChangePermissionRevoke() || !this._appVisibilityService.visibility() || (!this.activeConsumer() && this.isRecognizing())){
       //this._console.warn('🚫 Permissão revogada || 📱 Página oculta || 🛑 Sin consumidor activo - Deteniendo escucha');
        this._speechRecognitionService.stop();
        if (this.mediaStream) {
          this.releaseMicrophone();
        }
      }

    }, {'allowSignalWrites': true})
  }


  // private _initializeSpeechRecognition() {
  //   this._globalInstanceSpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  //   const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
  //
  //   if (!SpeechRecognition) {
  //     const error: UtilityMediaAccess.MicrophoneError = {
  //       name: 'NotSupportedError',
  //       message: 'SpeechRecognition não suportado neste navegador.'
  //     };
  //     this.error.set(error);
  //     console.error('❌ SpeechRecognition não suportado');
  //     this.recognitionState.set(UtilityMediaAccess.RecognitionState.ERROR);
  //     return;
  //   }
  //
  //   this.speechRecognition = new SpeechRecognition();
  //   this.speechRecognition.continuous = true;
  //   this.speechRecognition.interimResults = false;
  //   this.speechRecognition.lang = 'pt-BR';
  //   this.speechRecognition.onstart = () => {
  //     this._isRecognizing.set(true);
  //   }
  //
  //
  // }

  // private _createSpeechRecognitionInstance(): void {
  //   if (!this._globalInstanceSpeechRecognition) return;
  //
  //   // Limpiar instancia anterior
  //   //this.cleanupSpeechRecognition();
  //
  //   console.log('🔄 Criando nova instância SpeechRecognition');
  //   if (this.speechRecognition) {
  //
  //   } else {
  //     this.speechRecognition = new this._globalInstanceSpeechRecognition();
  //     this.speechRecognition.continuous = true;
  //     this.speechRecognition.interimResults = true;
  //     this.speechRecognition.lang = 'pt-BR';
  //
  //     // LISTENER DE RESULTADOS
  //     this.speechRecognition.onresult = (event: any) => {
  //       const transcript = Array.from(event.results)
  //         .map((result: any) => result[0].transcript)
  //         .join(' ')
  //         .toLowerCase();
  //
  //
  //       this.error.set(null);
  //       console.log('🎤 Transcripción recibida:', transcript);
  //       console.log('🎤 Transcripción total actual:', this.transcriptionSession());
  //     };
  //
  //     // LISTENER DE ERRORES
  //     this.speechRecognition.onerror = (event: UtilityMediaAccess.SpeechRecognitionErrorEvent) => {
  //       console.log(`⚠️ Error de reconocimiento: ${event.error}`);
  //
  //       // ERRORES QUE IGNORA COMPLETAMENTE - NO HACEN NADA
  //       const ignoredErrors = [
  //         'no-speech',      // Normal - no hay audio
  //         'audio-capture',  // Temporal - problema de captura
  //         'network',        // Temporal - conectividad
  //         'aborted'         // Temporal - proceso interrumpido
  //       ];
  //
  //       if (ignoredErrors.includes(event.error)) {
  //         console.log(`ℹ️ Error ignorado (normal): ${event.error} - Continuando escucha`);
  //         return; // NO HACER NADA - que onend maneje el reinicio
  //       }
  //
  //       // ERRORES CRÍTICOS - DETENER Y REPORTAR
  //       const criticalErrors = [
  //         'not-allowed',
  //         'service-not-allowed'
  //       ];
  //
  //       if (criticalErrors.includes(event.error)) {
  //         console.error(`🚨 Error crítico: ${event.error} - Deteniendo servicio`);
  //         this.recognitionState.set(UtilityMediaAccess.RecognitionState.ERROR);
  //         this.error.set({
  //           name: event.error,
  //           message: event.message || 'Error crítico en reconocimiento de voz'
  //         });
  //
  //         if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
  //           this.permissionState.set('denied');
  //           this.stopIntentionally();
  //         }
  //         return;
  //       }
  //
  //       // CUALQUIER OTRO ERROR - TRATARLO COMO TEMPORAL
  //       console.log(`⚡ Error temporal: ${event.error} - Se reiniciará automáticamente`);
  //     };
  //
  //     // LISTENER ONEND - CORAZÓN DEL SISTEMA
  //     this.speechRecognition.onend = () => {
  //       console.log('🔄 Reconocimiento terminado');
  //       const wasIntentionalStop = this.isIntentionalStop;
  //       this.recognitionState.set(UtilityMediaAccess.RecognitionState.IDLE);
  //       this.isIntentionalStop = false;
  //
  //       // Si fue parada intencional (usuario/sistema), no reiniciar
  //       if (wasIntentionalStop) {
  //         console.log('✋ Parada intencional - No reiniciar');
  //         return;
  //       }
  //
  //       // Si hay consumidor y página visible -> SIEMPRE REINICIAR
  //       if (this.activeConsumer() && this.pageVisibility() && !this.isRecognizing()) {
  //         console.log('🔄 Auto-reinicio - Manteniendo escucha continua');
  //         this.scheduleRestart();
  //       } else {
  //         console.log('⏸�� Sin condiciones para escucha - Quedando en idle');
  //       }
  //     };
  //
  //     // LISTENER ONSTART
  //     this.speechRecognition.onstart = () => {
  //       console.log('🎤 Escucha iniciada - Modo continuo activo');
  //       this.error.set(null);
  //       this.recognitionState.set(UtilityMediaAccess.RecognitionState.LISTENING);
  //     };
  //   }
  //
  //
  // }

  // MÉTODO PARA INICIAR ESCUCHA CONTINUA
  // private startContinuousListening(): void {
  //   if (this.isRecognizing() || !this.pageVisibility()) {
  //     console.log('⏭️ Ya escuchando o página no visible - Saltando inicio');
  //     return;
  //   }
  //
  //   console.log('🚀 Iniciando escucha continua');
  //   //this.createSpeechRecognitionInstance();
  //
  //   if (!this.speechRecognition) {
  //     console.error('❌ No se pudo crear instancia SpeechRecognition');
  //     return;
  //   }
  //
  //   try {
  //     this.isIntentionalStop = false;
  //     this.recognitionState.set(UtilityMediaAccess.RecognitionState.STARTING);
  //     this.speechRecognition.start();
  //   } catch (e: any) {
  //     if (e.name === 'InvalidStateError') {
  //       console.log('ℹ️ Ya iniciado - Ignorando error de estado');
  //       return;
  //     }
  //
  //     console.error('❌ Error al iniciar:', e);
  //     this.error.set({
  //       name: 'StartError',
  //       message: e.message || 'No se pudo iniciar reconocimiento'
  //     });
  //     this.recognitionState.set(UtilityMediaAccess.RecognitionState.ERROR);
  //   }
  // }

  // // PROGRAMAR REINICIO INMEDIATO
  // private scheduleRestart(): void {
  //   this.clearRestartTimer();
  //
  //   console.log(`⏰ Programando auto-reinicio en ${this.RESTART_DELAY}ms`);
  //   this.restartTimer = setTimeout(() => {
  //     // Verificar condiciones nuevamente antes de reiniciar
  //     if (this.activeConsumer() && this.pageVisibility()) {
  //       console.log('🔄 Ejecutando auto-reinicio programado');
  //       this.startContinuousListening();
  //     } else {
  //       console.log('⏸️ Condiciones cambiaron - Cancelando reinicio');
  //       this.recognitionState.set(UtilityMediaAccess.RecognitionState.IDLE);
  //     }
  //   }, this.RESTART_DELAY);
  // }

  // PARADA INTENCIONAL (SOLO USUARIO/SISTEMA)
  // private stopIntentionally(): void {
  //   console.log('🛑 Parada intencional solicitada');
  //   this.isIntentionalStop = true;
  //   this.clearRestartTimer();
  //   this.stopSpeechRecognition();
  // }

  private stopSpeechRecognition(): void {
     //this._console.log('🔇 Deteniendo reconocimiento');
      this._speechRecognitionService.stop();
  }

  private clearRestartTimer(): void {
    if (this.restartTimer) {
      clearTimeout(this.restartTimer);
      this.restartTimer = null;
    }
  }

  // private cleanupSpeechRecognition(): void {
  //   if (this.speechRecognition) {
  //     try {
  //       this.speechRecognition.stop();
  //     } catch (e) {
  //       // Ignorar errores al detener
  //     }
  //     this.speechRecognition.onresult = null;
  //     this.speechRecognition.onerror = null;
  //     this.speechRecognition.onend = null;
  //     this.speechRecognition.onstart = null;
  //     this.speechRecognition = null;
  //   }
  // }

  // MÉTODOS PÚBLICOS PARA GESTIÓN DE LOCKS

  public requestLock(consumerId: UtilityMediaAccess.MicrophoneConsumer, initialText: string = ''): boolean {
    if(this._devicesPermissionService.onChangePermissionRevoke()){
      this._devicesPermissionService.requestMicrophonePermission().then(state=>{
        if (state !=="granted"){
          this._snackbarService.info(`🚫 Lock negado para ${consumerId}. Acesso ao microfone não concedido`)
       //this._console.warn(`🚫 Lock denegado para ${consumerId}. Access a mic no concedido}`);
        return false;
        }
      })
    }
    if (this.isLocked() && this.activeConsumer() !== 'COMMAND_DETECTOR' && this.activeConsumer() !== consumerId) {
     //this._console.warn(`🚫 Lock denegado para ${consumerId}. Ya ocupado por ${this.activeConsumer()}`);
      this._snackbarService.info(`🚫 Lock negado para ${consumerId}. Já ocupado por ${this.activeConsumer()}`)
      return false;
    }
    this._speechRecognitionService.stop();
    setTimeout(()=>{
      this.initialPrefix.set(initialText);
      this._speechRecognitionService.start();
    }, 400)
    this.activeConsumer.set(consumerId);
   //this._console.log(`🔒 Lock concedido a ${consumerId} - Iniciando escucha continua`);
    return true;
  }

  public releaseLock(consumerId: UtilityMediaAccess.MicrophoneConsumer): void {
    if (this.activeConsumer() === consumerId) {
      this.activeConsumer.set(null);
     //this._console.log(`🔓 Lock liberado por ${consumerId} - Deteniendo escucha`);
    }
  }

  public isConsumerActive(consumerId: UtilityMediaAccess.MicrophoneConsumer): boolean {
    return this.activeConsumer() === consumerId;
  }

  // // MÉTODO PARA FORZAR REINICIO
  // public forceRestart(): void {
  //  //this._console.log('🔄 Reinicio forzado solicitado');
  //   this.error.set(null);
  //   if (this.activeConsumer() && this.pageVisibility()) {
  //     this.stopIntentionally();
  //     // El effect detectará el cambio y reiniciará automáticamente
  //     setTimeout(() => {
  //       if (this.recognitionState() === UtilityMediaAccess.RecognitionState.IDLE) {
  //         this.startContinuousListening();
  //       }
  //     }, 100);
  //   }
  // }

  public async getOrCreateMicrophoneStream(): Promise<MediaStream | null> {
    if (this.mediaStream && this.mediaStream.active) {
     //this._console.log('🎤 Stream ya activo, retornando existente.');
      return this.mediaStream;
    }

   //this._console.log('🎤 Solicitando nuevo stream de micrófono.');
    try {
      const stream = await this.mediaDevices?.getUserMedia({audio: true});
      this.mediaStream = stream;
      this.permissionState.set('granted');
      this.error.set(null);
     //this._console.log('✅ Acceso a micrófono concedido y stream creado.');

      // Listener para desconexión inesperada
      stream.getTracks().forEach(track => {
        track.onended = () => {
         //this._console.warn('⚠️ Track de micrófono terminado inesperadamente. Limpiando...');
          this.mediaStream = null; // Anula el stream
          this.error.set({
            name: 'DeviceDisconnected',
            message: 'Micrófono desconectado inesperadamente'
          });
          this.permissionState.set('denied');
        };
      });

      return stream;
    } catch (err: any) {
      const error: UtilityMediaAccess.MicrophoneError = {name: err.name, message: err.message};
      this.error.set(error);
      this.permissionState.set('denied');
     //this._console.error('❌ Error al acceder al micrófono:', err);

      // Manejo de errores específicos
      switch (err.name) {
        case 'NotAllowedError':
          this.error.set({
            name: 'NotAllowedError',
            message: 'Permiso denegado para acceder al micrófono'
          });
          break;
        case 'NotFoundError':
          this.error.set({
            name: 'NotFoundError',
            message: 'No se encontró dispositivo de micrófono'
          });
          this.permissionState.set('unsupported');
          break;
        case 'NotReadableError':
          this.error.set({
            name: 'NotReadableError',
            message: 'Micrófono no accesible (en uso o problema de hardware)'
          });
          break;
        case 'SecurityError':
          this.error.set({name: 'SecurityError', message: 'Requiere contexto seguro (HTTPS)'});
          break;
        default:
          this.error.set({name: 'UnknownError', message: 'Error inesperado al acceder micrófono'});
      }
      return null;
    }
  }

  public releaseMicrophone(): void {
   //this._console.log('🔇 Liberando micrófono completamente');
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => {
        track.stop();
        if (track.onended) {
          track.onended = null;}
      });
      this.mediaStream = null;
      this.permissionState.set('denied');
      this.error.set(null);
    }
    if (this.permissionStatus && this.permissionStatus.onchange) {
      this.permissionStatus.onchange = null;
      this.permissionStatus = null;
    }
  }

  ngOnDestroy(): void {
   //this._console.log('🗑️ Destruyendo MicrophoneService');
    this.clearRestartTimer();
    //this.cleanupSpeechRecognition();
    this.releaseMicrophone();
  }
}
